import { Globe } from "lucide-react";
import { Link } from "react-router";

/**
 * Visitor Intelligence — gated until a real backend visitor tracking endpoint ships.
 *
 * The previous version called GET /api/analytics/visitors/live which has
 * no deployed backend worker. This surface now shows an honest gate with
 * a link back to the live analytics dashboard.
 */
export default function VisitorIntelligence() {
  return (
    <div className="mx-auto max-w-2xl space-y-6 px-4 py-12">
      <div className="rounded-2xl border border-[var(--color-border)] bg-[var(--color-card)] p-8 text-center shadow-sm">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[var(--color-muted)]">
          <Globe className="h-6 w-6 text-[var(--color-muted-foreground)]" />
        </div>
        <h1 className="mt-4 text-2xl font-semibold text-[var(--color-foreground)]">
          Visitor Intelligence
        </h1>
        <p className="mt-2 text-sm text-[var(--color-muted-foreground)]">
          Real-time visitor tracking and identification is not yet available.
          The backend analytics visitor service has not been deployed, so this
          surface is gated until a real contract is live.
        </p>
        <Link
          to="/analytics/dashboard"
          className="mt-6 inline-block rounded-full bg-[var(--color-primary)] px-5 py-2.5 text-sm font-medium text-[var(--color-primary-foreground)]"
        >
          Back to Analytics Dashboard
        </Link>
      </div>
    </div>
  );
}
